export class Error {
    constructor(public severity: string, public summary: string, public detail: string) {}
}


// WEBPACK FOOTER //
// ./src/app/common/errors/error.ts